import { useMutation, useQueryClient } from '@tanstack/react-query';

import { kubesoloRetryInstall } from '@api/sdk.gen';

import { withError, withInvalidate } from '@/react-tools/react-query';

import { environmentQueryKeys } from '../queries/query-keys';
import { EnvironmentId } from '../types';

/** Installs KubeSolo again on the machine of an environment whose install failed, in the background. */
export function useRetryKubesoloInstallMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (environmentId: EnvironmentId) =>
      kubesoloRetryInstall({ path: { id: environmentId } }),
    ...withInvalidate(queryClient, [environmentQueryKeys.base()]),
    ...withError('Unable to retry the KubeSolo install'),
  });
}
